import React, { MouseEventHandler, ReactElement } from 'react';

import { track } from '../../services/analytics-client';

import styles from './A.module.scss';

export interface Props {
  children: string | ReactElement | ReactElement[];
  href: string;
  newTab?: boolean;
  trackingEventName?: string;
  variant?: 'a' | 'button';
}

export default function A({ children, href, newTab = false, trackingEventName, variant = 'a' }: Props): ReactElement {
  const rel = newTab ? 'noopener noreferrer' : undefined;
  const target = newTab ? '_blank' : undefined;

  let trackingEventHandler: MouseEventHandler<HTMLAnchorElement> | null = null;
  if (trackingEventName) {
    /*
      We can't use the Segment method trackLink because it does not accept the integrations, unlike track.
      Looks like somebody forgot to add that.
      Segment adds a 300ms delay and do a JS rediction, I do the same here.
    */
    trackingEventHandler = (event) => {
      event.preventDefault();
      track(trackingEventName);
      setTimeout(() => {
        window.location.href = href;
      }, 300);
    };
  }

  const onClick: MouseEventHandler<HTMLAnchorElement> = (event) => {
    if (trackingEventHandler) {
      trackingEventHandler(event);
    }
  };

  return (
    <a className={styles[`${variant}-basic`]} href={href} rel={rel} target={target} onClick={onClick}>
      {children}
    </a>
  );
}
